"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_core_1 = require("@patternfly/react-core");
function FormModal(props) {
    var _a = (0, react_1.useState)(false), validForm = _a[0], setValidState = _a[1];
    var childRef = (0, react_1.useRef)();
    var modalVariant = (0, react_1.useState)(props.modalVariant || react_core_1.ModalVariant.small)[0];
    var setValid = function (isValid) {
        setValidState(isValid);
    };
    return ((0, jsx_runtime_1.jsx)(react_core_1.Modal, __assign({ variant: modalVariant, title: props.title, description: props.description, isOpen: props.isModalOpen, onClose: props.handleClose, actions: [
            (0, jsx_runtime_1.jsx)(react_core_1.Button, __assign({ isDisabled: !validForm, variant: "primary", onClick: function () {
                    if (childRef.current) {
                        childRef.current.submitForm();
                    }
                } }, { children: "Confirm" }), "confirm"),
            (0, jsx_runtime_1.jsx)(react_core_1.Button, __assign({ variant: "link", onClick: props.handleClose }, { children: "Cancel" }), "cancel"),
        ] }, { children: props.content(setValid, childRef) })));
}
exports.default = FormModal;
